import Indicator, { IndicatorType } from '../../types/Indicator'

const Pressure: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'pressure',
  label: 'Pressure',
  fields: ['redPressure', 'greenPressure', 'redPressureAngle', 'greenPressureAngle'],
}

export default Pressure
